/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import Styles from './DisclaimerF1.css';

function DisclaimerF1() {
  return (
    <>
      <section id="disclaimer-f1">
        <ContainerHome24>
          <p className="disclaimer-f1-text">
            Promoção Partiu GP da Inglaterra com Santander: Certificado de Autorização SPA/ME Nº
            04.052484/2026. <br />
            Consulte período de participação e condições no Regulamento, disponível em:{' '}
            <a
              href="https://www.santander.com.br/partiugpdainglaterra"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.santander.com.br/partiugpdainglaterra
            </a>
          </p>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default DisclaimerF1;
